import { Box, Modal, Stack, ThemeProvider, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { ReactComponent as WarningIcon } from './Assets/warning.svg'
import ReCaptcha from './ReCaptcha'
import { storeElement } from 'GlobalStores/StoreElement'
import { customTheme } from '../Settings/PersonalTheme'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'

const ModalReCaptcha = observer(({ open, setOpen, extendsFunction }) => {
    const [reCaptchaVerify, setReCaptchaVerify] = React.useState(false)

    const handleReCaptCha = value => {
        setReCaptchaVerify(value)
        setOpen(value === true ? false : true)

        if (value === true) {
            extendsFunction()
        }
    }

    const style = {
        width: '100%',
        maxWidth: '540px',
        position: "absolute",
        transform: "translate(-50%, -50%)",
        top: "50%",
        left: "50%",
        outline: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    return (
        <ThemeProvider theme={customTheme}>
            <Modal open={open}>
                <Box sx={style}>
                    <Stack 
                        sx={{
                            width: 'auto',
                            background: '#FFFFFF',
                            borderRadius: "8px",
                            padding: '40px 24px',
                            margin: '15px',
                            alignItems: 'center',
                            '@media (min-width: 768px)': {
                                padding: '40px 70px',
                            }
                        }}
                    >
                        <WarningIcon />
                        <Typography 
                            mt="40px"
                            sx={{
                                fontSize: '24px',
                                fontWeight: 700,
                                color: '#003B6F',
                                textAlign: 'center',
                                fontFamily: 'Poppins, NotoSansThai',
                                lineHeight: '25px',
                            }}
                        >
                            <T>Oops</T>
                        </Typography>
                        
                        {/* <Typography 
                            sx={{
                                fontSize: '24px',
                                fontWeight: 700,
                                color: '#003B6F',
                                textAlign: 'center',
                                fontFamily: 'Poppins, NotoSansThai',
                                lineHeight: '25px',
                            }}
                        >
                            <T>something_went_wrong</T>
                        </Typography> */}

                        <Typography
                            mt="24px" 
                            variant='caption'
                            sx={{  
                                fontSize: '16px',
                                color: '#8A9BB0',
                                fontWeight: 400,
                                lineHeight: '20px',
                            }}
                        >
                            <T>desc_modal_recaptchaV2</T>
                        </Typography>

                        <Stack mt="40px">
                            <ReCaptcha handleReCaptCha={handleReCaptCha} />
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </ThemeProvider>
    )
  })

export default ModalReCaptcha